/**
 * 搜索
 */
const search = {
    namespaced: true,
    state: {
        searchCondition: {},
        //  选择尺寸
        pictureSize: null,
        //  选择图片制作方
        pictureProducer: null,
        //  选择图片查看筛选条件
        checkCondition: null,
        //  收藏图片列表筛选条件
        favoritePictureSort: null,
        filterCondition: []
    },
    mutations: {
        updateSearchCondition(state, obj) {
            state.searchCondition = obj;
        },
        updatePictureSize(state, val) {
            state.pictureSize = val;
        },
        updatePictureProducer(state, val) {
            state.pictureProducer = val;
        },
        updateCheckCondition(state, val) {
            state.checkCondition = val;
        },
        updateFavoritePictureSort(state, val) {
            state.favoritePictureSort = val;
        },
        updateFilterCondition(state, val) {
            state.filterCondition = val;
        }
    }
};
export default search;
